/*Main component of react app used to define routes and structure the UI.*/

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import CreateAccount from './components/CreateAccount';
import Login from './components/Login';
import Settings from './components/Settings';
import DevelopmentAdmin from './components/DevelopmentAdmin';
import Dashboard from './components/Dashboard';
import './App.css';
import GmailAuthCallback from './components/GmailAuthCallback';

function Home() {
  return (
    <div className="home-container">
      <div className="home-box">
        <h1>Dealmaster by Choice AI</h1>
        <div className="button-container">
          <Link to="/login">
            <button className="nav-button">Login</button>
          </Link>
          <Link to="/create-account">
            <button className="nav-button">Create Account</button>
          </Link>
          <Link to="/settings">
            <button className="nav-button">Settings</button>
          </Link>
          <Link to="/development-admin">
            <button className="nav-button">Development Admin</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin" element={<DevelopmentAdmin />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/gmail-auth-success" element={<GmailAuthCallback />} />
        <Route path="/gmail-auth-callback" element={<GmailAuthCallback />} />
      </Routes>
    </Router>
  );
}

export default App;
